import React, { Component } from 'react';
import produce from 'immer'
import { Button, ButtonGroup, Form, FormControl, InputGroup } from 'react-bootstrap';
import { MdGpsFixed } from "react-icons/md";
import { RiDeleteBin2Line } from 'react-icons/ri';
import { CgAddR } from "react-icons/cg";

export { PointFormEditor }

function PointFormEditor(props: {
  point: [number, number]
  label?: JSX.Element
  onChange: (p: [number, number]) => void
  onDelete?: () => void
  onAdd?: () => void
}) {

  const changeCoordinate = (index: number) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange(produce(props.point, (draft: [number, number]) => {
        draft[index] = parseFloat(e.target.value)
      }))
    }
  }

  const deletePoint = () => {
    if(props.onDelete) {
      props.onDelete()
    }
  }

  const addPoint = () => {
    if(props.onAdd) {
      props.onAdd()
    }
  }

  let x: string | number = props.point[0]
  let y: string | number = props.point[1]

  if(Number.isNaN(x)) {
    x = ''
  }
  if(Number.isNaN(y)) {
    y = ''
  }

  let renderLabel
  if(props.label) {
    renderLabel = props.label
  } else {
    renderLabel = <MdGpsFixed />
  }

  return <div>
      <InputGroup
        style={{margin: '1em'}}
      >
        <InputGroup.Prepend>
          <InputGroup.Text>
            {renderLabel}
          </InputGroup.Text>
        </InputGroup.Prepend>
        <InputGroup.Prepend>
          <InputGroup.Text>X:</InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control
          type="number"
          placeholder="X-Coordinate"
          aria-label="X-Coordinate"
          value={x}
          onChange={changeCoordinate(0)}
          style={{ maxWidth: '5em' }}
        />
        <InputGroup.Append>
          <InputGroup.Text>µm</InputGroup.Text>
        </InputGroup.Append>
        <InputGroup.Prepend>
          <InputGroup.Text>Y:</InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control
          type="number"
          placeholder="Y-Coordinate"
          aria-label="Y-Coordinate"
          value={y}
          onChange={changeCoordinate(1)}
          style={{ maxWidth: '5em' }}
        />
        <InputGroup.Append>
          <InputGroup.Text>µm</InputGroup.Text>
      { props.onDelete &&
        <Button
          onClick={deletePoint}
          variant="outline-remove-short"
        >
          <RiDeleteBin2Line />
        </Button>
      }
      { props.onAdd &&
        <Button
          onClick={addPoint}
          variant="outline-add-short"
        >
          <CgAddR />
        </Button>
      }
      </InputGroup.Append>
    </InputGroup>
    </div>
}
